import { Outlet, Navigate } from "react-router-dom";
import { useTokenRefresh } from "../hooks/useTokenRefresh";

function parseJwt(token) {
  const parts = token.split(".");
  if (parts.length !== 3) throw new Error("Invalid JWT format");
  const base64 =
    parts[1].replace(/-/g, "+").replace(/_/g, "/") +
    "==".slice(2 - (parts[1].length % 4));
  const json = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );
  return JSON.parse(json);
}

const checkAuth = () => {
  const token = localStorage.getItem("authToken");
  const refreshToken = localStorage.getItem("refreshToken");
  const companyName = localStorage.getItem("companyName");

  console.log("[ProtectedRoutes] === AUTH CHECK ===");
  console.log("[ProtectedRoutes] authToken exists:", !!token);
  console.log("[ProtectedRoutes] authToken value (first 50 chars):", token ? token.substring(0, 50) + "..." : "null");
  console.log("[ProtectedRoutes] refreshToken exists:", !!refreshToken);
  console.log("[ProtectedRoutes] companyName:", companyName);
  console.log("[ProtectedRoutes] localStorage keys:", Object.keys(localStorage));
  console.log("[ProtectedRoutes] =====================");

  // No token - not authenticated
  if (!token) {
    return { authenticated: false, hasValidClient: false, missingAdminName: false };
  }

  // Token'da adminName kontrolü
  try {
    const decoded = parseJwt(token);
    if (!decoded.adminName) {
      console.log("[ProtectedRoutes] adminName NOT FOUND in token - forcing Keycloak logout");
      return { authenticated: false, hasValidClient: false, missingAdminName: true };
    }
  } catch (e) {
    console.error("[ProtectedRoutes] Token parse error:", e);
    return { authenticated: false, hasValidClient: false, missingAdminName: true };
  }

  // Token exists, check for valid client
  if (!companyName || companyName === "DefaultClient") {
    return { authenticated: true, hasValidClient: false, missingAdminName: false };
  }

  // Check if companyName has corresponding data in localStorage
  const companyData = localStorage.getItem(companyName);
  if (!companyData) {
    return { authenticated: true, hasValidClient: false, missingAdminName: false };
  }

  return { authenticated: true, hasValidClient: true, missingAdminName: false };
};

const ProtectedRoutes = () => {
  console.log("[ProtectedRoutes] Component rendering...");

  // Token yenileme mekanizmasını başlat
  useTokenRefresh();

  const { authenticated, hasValidClient, missingAdminName } = checkAuth();

  console.log("[ProtectedRoutes] Authenticated result:", authenticated);
  console.log("[ProtectedRoutes] Has valid client:", hasValidClient);

  if (!authenticated || missingAdminName) {
    if (missingAdminName) {
      console.log("[ProtectedRoutes] MISSING adminName - Redirecting to /login");
    } else {
      console.log("[ProtectedRoutes] NOT AUTHENTICATED - Redirecting to /login");
    }
    return <Navigate to="/login" />;
  }

  if (!hasValidClient) {
    console.log("[ProtectedRoutes] NO VALID CLIENT - Redirecting to /client");
    return <Navigate to="/client" />;
  }

  console.log("[ProtectedRoutes] AUTHENTICATED WITH VALID CLIENT - Rendering Outlet");
  return <Outlet />;
};

export default ProtectedRoutes;
